import '../stylus/main.styl';

import { setup, scan } from '@lernetz/ts-lib';
import { SetupConfig, data, route } from '@lernetz/ts-lib/src/Setup';
import { context } from '@lernetz/ts-lib/src/view/Template';

import { modelRegistry, viewRegistry } from './register';
import { CookieBanner } from 'cookie-banner/CookieBanner';


export function init(config: SetupConfig) {

    setup(config, modelRegistry);

    context.logging = true;

    context.setup = {
        data,
    };

    context.downloadPath = function(file_name: string) {
        return decodeURIComponent(route('download', { file_name, 'locale': data('currentLocale') }).url());
    }
    context.staticImagePath = function( fileName: string ) {
        console.log( 'staticImagePath', fileName, decodeURIComponent(route('staticImage', { fileName }).url() ) );
        return decodeURIComponent(route('staticImage', { fileName }).url());
    }
    context.imagePath = function(image: { file_name:string, ext:string }, preset: string = 'medium' ) {
        let ext = 'webp';
        if( image.ext === 'svg' ) {
            preset = 'original';
        }
        else {
            ext = 'webp';
        }
        if( preset === 'original' ) {
            ext = image.ext;
        }
        return decodeURIComponent(route('asset', { file_name: image.file_name, preset, ext }).url());
    }
    context.isStartPage = function() {
        return data('isStartPage');
    }
    context.getStartPageUrl = function() {
        return route('startPage').url();
    }

    context.cookieBanner = new CookieBanner();

    scan({ root: document.body, data: { page: data('page') }, registry: viewRegistry });
};
